/* oxlint-ignore react/no-array-index-key */
import { Stack, Text, type TextProps } from '@chakra-ui/react'

import TextWithLinks from '@/components/UI/TextWithLinks/TextWithLinks'

import textToLines from './textToLines'

export default function TextWithLines({
  text,
  maxLines = 50,
  enableLinks = false,
  ...textProps
}: {
  text: string | null
  maxLines?: number
  enableLinks?: boolean
} & TextProps): React.ReactElement {
  const lines = textToLines(text ?? '', maxLines)

  return (
    <Stack>
      {lines.map((line, i) => (
        <Text key={`line-${line.slice(0, 50)}-${i}`} {...textProps} wordBreak="break-word">
          {enableLinks ? <TextWithLinks text={line} {...textProps} /> : line}
        </Text>
      ))}
    </Stack>
  )
}
